import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import '../../styles/map.css';

function TempleMap({ temples, onTempleClick }) {
  const { t } = useTranslation();
  const [selectedTemple, setSelectedTemple] = useState(null);
  const [map, setMap] = useState(null);

  // Create temple icon
  const templeIcon = L.icon({
    iconUrl: '/images/temple-marker.svg',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });

  useEffect(() => {
    if (map && temples.length > 0) {
      // Fit bounds to show all temples
      const bounds = L.latLngBounds(temples.map(temple => temple.coordinates));
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [map, temples]);

  const handleMarkerClick = (temple) => {
    setSelectedTemple(temple);
  };

  // Calculate distances between temples
  const calculateDistance = (coord1, coord2) => {
    const R = 6371; // Earth's radius in km
    const lat1 = coord1[0] * Math.PI / 180;
    const lat2 = coord2[0] * Math.PI / 180;
    const deltaLat = (coord2[0] - coord1[0]) * Math.PI / 180;
    const deltaLon = (coord2[1] - coord1[1]) * Math.PI / 180;

    const a = Math.sin(deltaLat/2) * Math.sin(deltaLat/2) +
              Math.cos(lat1) * Math.cos(lat2) *
              Math.sin(deltaLon/2) * Math.sin(deltaLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return (R * c).toFixed(2);
  };

  return (
    <Box sx={{ height: '600px', width: '100%', position: 'relative' }}>
      <MapContainer
        center={[26.7922, 82.1998]} // Center on Ram Mandir
        zoom={15}
        style={{ height: '100%', width: '100%' }}
        whenCreated={setMap}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {temples.map((temple) => (
          <Marker
            key={temple.id}
            position={temple.coordinates}
            icon={templeIcon}
            eventHandlers={{
              click: () => handleMarkerClick(temple),
            }}
          >
            <Popup className="temple-popup">
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {temple.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {temple.description}
                  </Typography>
                  <Typography variant="body2">
                    {t('Timings')}: {temple.timings}
                  </Typography>
                  {selectedTemple && temple.id !== selectedTemple.id && (
                    <Typography variant="body2">
                      {t('Distance')}: {calculateDistance(temple.coordinates, selectedTemple.coordinates)} km
                    </Typography>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => onTempleClick(temple.id)}
                    sx={{ mt: 1 }}
                  >
                    {t('View Details')}
                  </Button>
                </CardContent>
              </Card>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </Box>
  );
}

export default TempleMap;
